export const repeat = (times: number, render: (index: number) => React.ReactNode) => {
    return new Array(times).fill(undefined).map((_, index) => render(index));
};
